// @flow
import React from 'react';
import {
  useSelector,
  useDispatch,
} from 'react-redux';
import ModalDialog from '@atlaskit/modal-dialog';

import type {
  StatelessFunctionalComponent,
  Node,
} from 'react';
import type {
  Id,
  Dispatch,
} from 'chronos-types';

import * as selectors from 'chronos-selectors';
import * as actions from 'chronos-actions';


type Props = {
  isOpen: boolean,
  worklogId: Id,
  dispatch: Dispatch,
};

const mapState = state => ({
  isOpen: selectors.getUiState('confirmDeleteWorklogIsOpen')(state),
  worklogId: selectors.getUiState('deleteWorklogId')(state),
});

const ConfirmDeleteWorklogModal: StatelessFunctionalComponent<Props> = (): Node => {
  const {
    isOpen,
    worklogId,
  } = useSelector(mapState);

  const dispatch: Dispatch = useDispatch();

  return (isOpen && (
    <ModalDialog
      appearance="danger"
      heading="Delete worklog"
      onClose={() => {
        dispatch(actions.setUiState({
          confirmDeleteWorklogIsOpen: false,
        }));
      }}
      actions={[
        {
          text: 'Delete',
          onClick: () => {
            dispatch(actions.deleteWorklogRequest(worklogId));
            dispatch(actions.setUiState({
              confirmDeleteWorklogIsOpen: false,
            }));
          },
        },
        {
          text: 'Close',
          onClick: () => {
            dispatch(actions.setUiState({
              confirmDeleteWorklogIsOpen: false,
            }));
          },
        },
      ]}
    >
      <p>
        Are you sure you want to delete this worklog?
      </p>
    </ModalDialog>
  ));
};

export default ConfirmDeleteWorklogModal;
